<template>
	<div class="old_page">
		<div class="old_pc" v-if="!isPhone">
			<div class="page_con">
				<div class="pc_box1">
					<p class="pb_p1" data-aos="fade-up">
						剑南春防伪体系
					</p>
					<p class="pb_p2" data-aos="fade-up">
						三重
					</p>
					<ul class="pb_p3 flex3" data-aos="fade-up">
						<li class="p3_item">
							<img src="@/images/fangwei/omg1.png" />
							<p class="p3_item_p1">新型防伪标签</p>
							<p class="p3_item_p2">
								第一重：是指剑南春外盒新采用的是与最新版纸币防伪相似的世界领先的新型防伪标签。
							</p>
						</li>
						<li class="p3_item">
							<img src="@/images/fangwei/omg2.png" />
							<p class="p3_item_p1">破坏性拉环防伪</p>
							<p class="p3_item_p2">
								第二重：为防止印有精密防伪标签的剑南春外包装盒被制假者利用，新的剑南春外包装盒采用了一次性开启拉环，当消费者通过防伪标签确认无误后，只要正常开启拉环，外包装盒即产生不可修复性破坏，彻底杜绝假冒者回收利用的可能！
							</p>
						</li>
						<li class="p3_item">
							<img src="@/images/fangwei/omg3.png" />
							<p class="p3_item_p1">12位纹理防伪标签</p>
							<p class="p3_item_p2">
								第三重：纹理防伪标签的序号是唯一的（一瓶一号），纹理纤维的分布与查询结果一致，纤维能从纸张中挑出，以上三项都必须同时满足。不同时期的纹理防伪标签采用不同的形状和纤维丝，但基本原理一致，均需符合上述条件。
							</p>
						</li>
					</ul>
				</div>
				<div class="pc_box2" data-aos="fade-up">
					<div class="pb_p2">八关</div>
					<ul class="passes flex3">
						<li class="pass_item" :class="actIndex == index ? 'act1' : ''" @click="selAct(index)"
							v-for="(item, index) in glist" :key="index">
							<p>{{ item.text1 }}</p>
							<p>{{ item.text2 }}</p>
						</li>
					</ul>
					<div class="ps_box">
						<div v-for="(item, index) in glist" :key="index">
							<div class="ps_con flex1" v-if="actIndex == index">
								<div class="psn_left">
									<img :src="item.img" />
								</div>
								<div class="psn_right">
									<p>{{ item.text1 }}</p>
									<p>{{ item.text2 }}</p>
									<p>
										{{ item.text3 }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pc_box3" data-aos="fade-up">
					<div class="pb_p1">防伪打假</div>
					<img class="fw_img" src="@/images/fangwei/fw7.png" />
				</div>
				<div class="pc_box4" data-aos="fade-up">
					<div class="pb_p1">更多防伪</div>
					<ul class="search_list flex3">
						<li class="search_item">
							<div class="stm_con">
								<p>微信查询</p>
								<p>
									关注剑南春官方微信公众号，点击底部菜单：快捷服务—防伪查询。
								</p>
							</div>
						</li>
						<li class="search_item">
							<div class="stm_con">
								<p>短信查询</p>
								<p>
									将防伪标签上的序号发至<span style="color: #e40000; font-weight: 700">13976088088</span>接收彩信后可查询真伪。
								</p>
							</div>
						</li>
						<li class="search_item">
							<div class="stm_con">
								<p>电话查询</p>
								<p>
									拨打电话<span style="color: #e40000; font-weight: 700">400-6800315</span>按语音提示进行操作。
								</p>
							</div>
						</li>
						<li class="search_item">
							<div class="stm_con">
								<p>网络查询</p>
								<p>
									访问<a href="https://www.315net.com" target="_blank">www.315net.com</a>按页面提示输入序号即可查询真伪。
								</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			actIndex: 0,
			isPhone: this.$isMobile,
			glist: [
				{
					text1: "第一关",
					text2: "防复印橘色",
					text3: "剑南春新型防伪标签采用了防复印橘色，在紫外灯照射下“防伪”和“标识”汉字处会出现防复印的橘色及随机荧光点。一些消费者喜欢随身携带微型紫外灯验钞机，可用它一照轻松识别，非常方便。",
					img: require("@/images/fangwei/g1.png"),
				},
				{
					text1: "第二关",
					text2: "烫金徽标",
					text3: "使用了高精度烫金徽标。",
					img: require("@/images/fangwei/g2.png"),
				},
				{
					text1: "第三关",
					text2: "热敏油墨",
					text3: "防伪标签右侧遇热后，粉红色会减弱变淡，散热后复原。",
					img: require("@/images/fangwei/g3.png"),
				},
				{
					text1: "第四关",
					text2: "中文微缩字",
					text3: "在剑南春新型防伪标上“防伪”与“标识”字样下，有高精度中文微缩文字“中国名酒剑南春”，在放大镜下清晰可见。",
					img: require("@/images/fangwei/g4.png"),
				},
				{
					text1: "第五关",
					text2: "英文微缩字",
					text3: "在剑南春新型防伪标上的两侧纽索纹下方，有一行蓝色高精度英文 “JIANNANCHUNDISTILLERY” 字样，在放大镜下可以清晰看到。",
					img: require("@/images/fangwei/g5.png"),
				},
				{
					text1: "第六关",
					text2: "安全模切",
					text3: "剑南春新型防伪标采用安全模切技术，一般消费者凭肉眼就能看到标志图案边缘的模切。",
					img: require("@/images/fangwei/g6.png"),
				},
				{
					text1: "第七关",
					text2: "镜像油墨",
					text3: "剑南春新型防伪标签采用了镜像油墨技术，在检测窗下，防伪标两侧的纽索纹颜色为红绿不同。",
					img: require("@/images/fangwei/g7.png"),
				},
				{
					text1: "第八关",
					text2: "激光油墨",
					text3: "剑南春新型防伪标签采用了激光油墨技术，在激光笔照射下，标签左右纽索纹和 R中，能测出亮点。",
					img: require("@/images/fangwei/g8.png"),
				},
			],
		};
	},
	methods: {
		selAct(index) {
			this.actIndex = index;
			this.$forceUpdate();
		},
	},
};
</script>

<style lang="scss">
.act1 {
	color: #d64545 !important;
	font-weight: 700 !important;
}
.pb_p1 {
	text-align: center;
	color: #c0494b;
	font-size: 36px;
	margin-bottom: 50px;
}
.pb_p2 {
	text-align: center;
	color: #535353;
	font-size: 36px;
	margin-bottom: 45px;
}
.old_page {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	background-image: url("../../images/bgimg3.png");
	min-height: 800px;
	.old_pc {
		margin-top: 76px;
		width: 100%;
		box-sizing: border-box;
		padding: 74px 20px 10px 20px;
		.page_con {
			max-width: 1200px;
			margin: 0 auto;
			.pc_box1 {
				padding-bottom: 50px;
				.pb_p3 {
					align-items: flex-start;
					margin: 0 -65px;
					.p3_item {
						width: 33.3%;
						padding: 0 65px;
						img {
							width: 300px;
							height: 300px;
							margin: 0 auto 36px;
						}
						.p3_item_p1 {
							text-align: center;
							color: #333;
							font-size: 24px;
							margin-bottom: 15px;
						}
						.p3_item_p2 {
							color: #555;
							font-size: 14px;
							line-height: 1.8;
							text-align: left;
						}
					}
				}
			}
			.pc_box2 {
				margin-bottom: 75px;
				.passes {
					margin-bottom: 30px;
					padding: 0 20px;
					box-sizing: border-box;
                    flex-wrap: wrap;
					.pass_item {
						color: #555;
						font-size: 16px;
						line-height: 1.8;
						position: relative;
						padding-right: 78px;
						box-sizing: border-box;
						cursor: pointer;
						&::after {
							content: "";
							position: absolute;
							right: 18px;
							top: 15px;
							width: 64px;
							height: 2px;
							background-image: url("../../images/fangwei/point.png");
							background-repeat: no-repeat;
							background-position: 50%;
						}
						&:nth-last-child(1) {
							padding-right: 0;
							&::after {
								content: "";
								background-image: url("");
							}
						}
						p {
							text-align: left;
						}
					}
				}
				.ps_box {
					.ps_con {
						min-height: 420px;
						background-color: #fff;
						box-sizing: border-box;
						padding: 80px 70px;
						.psn_left {
							width: 50%;
							img {
								width: 100%;
							}
						}
						.psn_right {
							width: 50%;
							padding-left: 70px;
							text-align: left;
							p {
								&:nth-child(1) {
									color: #c33;
									font-size: 16px;
									font-weight: 700;
									margin-bottom: 20px;
								}
								&:nth-child(2) {
									color: #d64545;
									font-size: 30px;
									margin-bottom: 20px;
								}
								&:nth-child(3) {
									color: #333;
									font-size: 18px;
									line-height: 1.9;
								}
							}
						}
					}
				}
			}
			.pc_box3 {
				margin-bottom: 106px;
				box-shadow: 0 10px 10px 0 hsla(0, 0%, 71%, 0.6);
				.fw_img {
					width: 100%;
				}
			}
			.pc_box4 {
				margin-bottom: 76px;
				.search_list {
					margin: 0 -20px;
					flex-wrap: wrap;
					.search_item {
						box-sizing: border-box;
						width: 50%;
						margin-bottom: 46px;
						padding: 0 20px;
						.stm_con {
							background-color: #fff;
							border-left: 6px solid #dfd0b7;
							padding: 38px 32px 36px;
							p {
								text-align: left;
								a {
									color: #d43235;
									font-weight: bold;
									text-decoration: none;
								}
								&:nth-child(1) {
									color: #1c1c1c;
									font-size: 24px;
									margin-bottom: 20px;
								}
								&:nth-child(2) {
									color: #1c1c1c;
									font-size: 16px;
									height: 40px;
									overflow: hidden;
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>